module.exports = __webpack_public_path__ + "img/register-bg.8261cb65.png";